import { ExpressionRule } from "../../ExpressionRule";
import { DateDataDefinition } from "../../../Common/Data/Definitions/DateDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class DateGetTodayExpression extends ExpressionRule {
    readonly __type: string = "Date Get Today";
    readonly __ruleName: string = "Get Today";

    constructor() {
        super();

        this.expressionValueType = new DateDataDefinition();
    }

    // eslint-disable-next-line
    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return new Date();
    }
}
